export default __webpack_public_path__ + "static/media/information--trail-crossing--g3.9ee9d069.png";